import type { AxiosError } from 'axios';

import { downloadFile } from '../../util/downloadFile';
import { DownloadFileError } from '../../util/downloadFileError';
import { campaignGraphqlManager } from '../campaignGraphqlManager';
import { DEFAULT_CUSTOM_PACING_API_ROUTE } from './constants';

const CUSTOM_PACING_TEMPLATE_FILE_NAME = 'custom-pacing-template.csv';
const DOWNLOAD_CUSTOM_PACING_TEMPLATE_ENDPOINT = `${DEFAULT_CUSTOM_PACING_API_ROUTE}/download-csv-template`;
const CUSTOM_PACING_TEMPLATE_FILE_TYPE = 'text/csv';

const DEFAULT_DOWNLOAD_CUSTOM_PACING_TEMPLATE_ERROR_NAME = 'Cannot download custom pacing template!';
const DEFAULT_DOWNLOAD_CUSTOM_PACING_TEMPLATE_ERROR_MESSAGE = 'Unknown issue occurred!';

type DownloadCustomPacingTemplateErrorResponse = {
  message?: string;
};

const makeErrorInfoFromResponse = (error: AxiosError<DownloadCustomPacingTemplateErrorResponse>): DownloadFileError => {
  if (!error.response?.data.message) {
    return new DownloadFileError(
      DEFAULT_DOWNLOAD_CUSTOM_PACING_TEMPLATE_ERROR_MESSAGE,
      DEFAULT_DOWNLOAD_CUSTOM_PACING_TEMPLATE_ERROR_NAME
    );
  }

  return new DownloadFileError(error.response.data.message, DEFAULT_DOWNLOAD_CUSTOM_PACING_TEMPLATE_ERROR_NAME);
};

export const downloadCustomPacingTemplate = async (): Promise<void> => {
  return await downloadFile(
    () => {
      return campaignGraphqlManager
        .get(DOWNLOAD_CUSTOM_PACING_TEMPLATE_ENDPOINT, {
          responseType: 'blob',
        })
        .then((response) => response.data)
        .catch((error: AxiosError<DownloadCustomPacingTemplateErrorResponse>) =>
          Promise.reject(makeErrorInfoFromResponse(error))
        );
    },
    CUSTOM_PACING_TEMPLATE_FILE_NAME,
    CUSTOM_PACING_TEMPLATE_FILE_TYPE
  );
};
